import React, { useEffect, useState } from 'react'
import PageLayout from '../components/templates/page-layout/page-layout'
import { StaticImage } from 'gatsby-plugin-image'
import { getQuestions } from '../constants/faqs'
import useMediaQuery from '../utils/useMediaQuery'
import { triggerPageView, triggerTag } from '../utils/taggeo'
import CrazyEgg from '../utils/CrazyEgg'
import './styles/preguntas-frecuentes.scss'

const questions = getQuestions()
const numberOfQuestions = questions.length
CrazyEgg()

function FAQPage() {
  const isMobile = useMediaQuery(960)
  const [numberRenderItems, setNumberRenderItems] = useState(isMobile ? 4 : 8)
  const [seeMore, setSeeMore] = useState(false)
  const handleClickSeeMore = () => {
    if (seeMore) {
      setSeeMore(false)
      setNumberRenderItems(isMobile ? 4 : 8)
    } else {
      setSeeMore(true)
      setNumberRenderItems(numberOfQuestions)
    }
  }

  useEffect(
    function handleIsMobileChange() {
      setNumberRenderItems(isMobile ? 4 : 8)
    },
    [isMobile]
  )

  useEffect(() => {
    triggerPageView()
  }, [])

  return (
    <PageLayout className="background-play">
      <div className="f-faq-logo_vschool">
        <StaticImage
          src="../assets/images/play/logo-play.png"
          alt="vschool logo"
          placeholder="blurred"
          width={500}
        />
      </div>
      <div className="f-faq-mens_and_bang">
        <StaticImage
          src="../assets/images/faq/mens_and_bang.png"
          alt="menstruación y "
          placeholder="blurred"
          width={450}
        />
      </div>
      <div className={'flex full-view f-faq'}>
        <div className="f-faq-title">
          <StaticImage
            src="../assets/images/faq/faq.png"
            alt="control de videojuegos"
            className="f-faq-title__logo"
            placeholder="blurred"
            width={50}
          />
          <h1>
            <i>Preguntas frecuentes</i>
          </h1>
        </div>
        <div className="f-faq-questions">
          {questions.map((elem, i) => {
            if (i + 1 > numberRenderItems) {
              return null
            } else {
              return <CardCollapsible {...elem} key={i} />
            }
          })}
        </div>
        <button onClick={handleClickSeeMore} className="f-faq-seeMore">
          {!seeMore ? 'Ver más' : 'Ver menos'}
        </button>
      </div>
    </PageLayout>
  )
}

export default FAQPage

const CardCollapsible = ({
  question,
  answer,
}: {
  question: string
  answer: React.JSX.Element
}) => {
  const [isActive, setIsActive] = useState(false)
  const handlerOnClick = () => {
    triggerTag('9A', { label: question })
    setIsActive(!isActive)
  }
  return (
    <div onClick={handlerOnClick} className="f-faq-item">
      <span className={`f-faq-item__arrow ${isActive ? 'active' : ''}`} />
      <b className={`${isActive ? 'active' : ''}`}>{question}</b>
      <div className={`${isActive ? 'active' : ''}`}>{answer}</div>
    </div>
  )
}
